export default "__VITE_ASSET__f8c91fda__"